import React from 'react';
import { formatNumber } from '../../../utils/number';
import styles from './DimensionValue.module.scss';

interface DimensionValueProps {
    value: number | null;
}

/** Габарит в миллиметрах. Незаполненное значение — не ноль, и выглядит иначе. */
export function DimensionValue({ value }: DimensionValueProps) {
    if (value === null) {
        return <span className={styles.empty}>—</span>;
    }

    return <>{formatNumber(value)}</>;
}
